import { render, staticRenderFns } from "./Presentacion18Page.vue?vue&type=template&id=23ac73cd"
import script from "./Presentacion18Page.js?vue&type=script&lang=js&external"
export * from "./Presentacion18Page.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports